
const m = window.require("discourse/helpers/d-icon");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
